import {
  RESET_REDUX,
  REQUEST_LOGIN,
  RECEIVE_LOGIN,
  RESET_LOGIN,
  SET_REMEMBER_ME,
} from "../actions/index";

import produce from "immer";

const initialState = {
  username: "Demo User",
  password: null,
  loginFetching: false,
  loginEstablished: true,
  rememberMeAllowed: true,
  rememberMe: true,
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case REQUEST_LOGIN: {
        draft.loginFetching = true;
        break;
      }

      case RECEIVE_LOGIN: {
        draft.loginEstablished = true;
        draft.username = action.username;
        draft.password = action.password;
        draft.loginFetching = false;
        draft.rememberMeAllowed = action.rememberMeAllowed;
        break;
      }

      case SET_REMEMBER_ME: {
        draft.rememberMe = action.rememberMe;
        break;
      }

      case RESET_LOGIN: {
        draft.username = null;
        draft.password = null;
        draft.loginFetching = false;
        break;
      }

      case RESET_REDUX: {
        let renewState = {};
        if (action.keepUser) {
          // If the user quits study WITHOUT logging out then do NOT reset the user log in info
          renewState = {
            ...initialState,
            rememberMeAllowed: draft.rememberMeAllowed,
            username: draft.username,
            password: draft.password,
            rememberMe: draft.rememberMe,
          };
        } else {
          renewState = initialState;
        }
        return renewState;
      }

      default:
        return draft;
    }
  });
